export default "__VITE_ASSET__26hBHf2A__"